import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const AccountGrpcContractProvider: Provider = {
  provide: MainApi.AccountGrpcContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.AccountGrpcContractClient, 'mainApi'),
};
